module.exports = __webpack_public_path__ + "img/awards3.addaba9b.svg";